import FlorenzSearchInput from "./FlorenzSearchInput";

export default FlorenzSearchInput;